/**
 * registerServiceWorker — installs /sw.js when the app loads in a
 * production build. The worker pre-caches the shell so the next
 * launch from the home screen is instant, and is what satisfies
 * Chrome / Edge's "installable PWA" checklist (alongside the
 * manifest + a valid `start_url`).
 *
 * We skip registration in dev (Vite dev server) because:
 *   - Vite serves files with cache-busting hashes, and the SW's
 *     shell-cache fights HMR.
 *   - sw.js sits at /sw.js which conflicts with Vite's middleware
 *     in some configurations.
 *
 * Updates are picked up on the next full page load — the worker
 * calls `skipWaiting()` so newer versions activate immediately.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  // Defer to `load` so SW registration doesn't compete with the
  // initial paint / hydration.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => {
        // Non-fatal — the app still works without the worker; we
        // just lose the "Install app" prompt + shell pre-cache.
        console.warn('[sw] registration failed', err);
      });
  });
}
